var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"win"},[(_vm.certificate)?_c('div',{staticClass:"back"},[_c('canvas',{attrs:{"id":"myCanvas","width":"300","height":"604"}}),_c('img',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"id":"scream","src":require("../assets/certificate_content.png"),"alt":"The Scream","width":"300","height":"604"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }